import React from 'react';

export default class TabContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected : props.selected
        };

        this.generateTabLinks = this.generateTabLinks.bind(this);
        this.renderTabContent = this.renderTabContent.bind(this);
        this.renderTabTitle   = this.renderTabTitle.bind(this);
        this.handleTabClick   = this.handleTabClick.bind(this);
    }

    renderTabContent() {
        return (
            <div className="tab-content">
                {
                    React.cloneElement(this.props.children[this.state.selected],
                        { 'isActive': true })
                }
            </div>
        );
    }

    handleTabClick(index, event) {
        event.preventDefault();
        this.setState({
            selected : index
        });
    }

    generateTabLinks(child, index) {
        let activeClass = this.state.selected === index ? 'active' : '';
        return (
            <li key={index} className={child.props.classNames}>
                <a
                    href      = "#"
                    className = {activeClass}
                    onClick   = {this.handleTabClick.bind(this, index)}
                >
                    {child.props.label}
                </a>
            </li>
        );
    }

    renderTabTitle() {
        return (
            <ul className="nav nav-pills nav-justified">
                {this.props.children.map(this.generateTabLinks)}
            </ul>
        );
    }

    render() {
        return (
            <div className={this.props.classNames}>
                { this.renderTabTitle() }
                { this.renderTabContent() }
            </div>
        );
    }
}

TabContainer.propTypes = {
    selected : React.PropTypes.number
}

TabContainer.defaultProps = {
    selected : 0,
    children : React.PropTypes.oneOfType([
        React.PropTypes.array,
        React.PropTypes.element
    ]).isRequired
}



// WEBPACK FOOTER //
// src/components/generic/tab-container.js